import React, {useEffect, useState} from 'react';
import useStyles from "../../../assets/styles/ProgramRatingStyles";
import {
    Container,
    Typography,
    Card,
    CardContent,
    Grid,
    Box,
    TextField,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button
} from '@material-ui/core';
import {
    Autocomplete,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Step,
    StepLabel,
    Stepper
} from "@mui/material";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import { APP_STATUS, ASSESSMENT_REQ_TYPES } from "../../../utils/constants";
import { REGIONS, REGIONS_MAP } from "../../../utils/META/cat_101";
import {toastWarning} from "../../../utils/utils";
import {ASSESSMENT_STEPS} from "../../../utils/RatingFlowSteps";

const RatingSelectAssessmentView = ({ options, actions, data }) => {
    const classes = useStyles();
    const { submittedFormData, key_desc, formData, setFormData, currentStatus,ASSESSMENT_STEPS, application_id, status} = data;
    const { loading, isAppAligned, selectedCard,showForm } = options;
    const { formSubmitAction, submitAddAssessmentReqAction,goToDqAssessAction, cardClickAction, selectedCardAction,setStatus, accessAssessmentAction, publishAssessmentAction, setCurrentStatus } = actions;
    const [selectedAssessment, setSelectedAssessment] = useState(null);
    const activeStep = ASSESSMENT_STEPS.findIndex(step => step.status === currentStatus);

    useEffect(() => {
        if (status !== APP_STATUS.READY_TO_CERTIFY && status !== APP_STATUS.ASSESSMENTS_READY) {
            const interval = setInterval(() => {
                window.location.reload();
            }, 2000);
            return () => clearInterval(interval);
        }
    }, [status]);

    const [currentScreen, setCurrentScreen] = useState(
        status === APP_STATUS.ASSESSMENTS_READY ? 'preview' : 'selectAssessment'
    );
    const [openDialog, setOpenDialog] = useState(false);
    const [openAssessDialog, setOpenAssessDialog] = useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    const handleAccessAssessment = (programId, program_state) => {
        if (accessAssessmentAction) {
            accessAssessmentAction(programId, program_state);
        }
    };

    const handlePublishConfirmed = () => {
        handleCloseDialog();
        publishAssessmentAction();
        accessAssessmentAction(application_id, status);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCountryChange = (event, value) => {
        const nameOfCountriesString = value.map(item => REGIONS_MAP[item.value]?.name || item.value).join(', ');
        setFormData(prev => ({ ...prev, nameOfCountries: nameOfCountriesString }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        submitAddAssessmentReqAction();
        setOpenAssessDialog(true);
    };
    useEffect(() => {
        if (submittedFormData) {
            setOpenAssessDialog(true);
        }
    }, [submittedFormData]);

    const handleCardClick = (buttonIndex) => {
        // Update both local state and parent component's state
        setSelectedAssessment(buttonIndex);
        cardClickAction(buttonIndex);
    };

    const goToDqAssess = () => {
            goToDqAssessAction();
    };

    const validateForm = () => {
        let isValid = true;

        if (!formData.noOfUsers) {
            toastWarning("Please enter expected number of users");

            isValid = false;
        }

        if (!formData.nameOfCountries || formData.nameOfCountries.length === 0) {
            toastWarning("Please select at least one country");
            isValid = false;
        }

        return isValid;
    };
    // const handleBackToSelection = () => {
    //     setStatus(APP_STATUS.READY_TO_CERTIFY);
    //     setSelectedAssessment(null);
    //     setCurrentScreen('selectAssessment');
    // };

    const handleBackFromPreview = () => {
        setCurrentScreen('selectAssessment');
    };

    if (status === APP_STATUS.READY_TO_CERTIFY || !status) {
        return (
            <Container className={classes.assessmentContainer}>
                <Box sx={{ p: 3 }}>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        sx={{
                            '& .MuiStepLabel-root .Mui-completed': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-active': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-disabled': {
                                color: '#ff6468ff',
                                opacity: 0.5
                            },
                            '& .MuiStepConnector-root .MuiStepConnector-line': {
                                borderColor: '#ff6468ff',
                                borderTopWidth: '6px',
                                // marginTop: '-12px'
                            }
                        }}
                    >
                        {ASSESSMENT_STEPS.map((step) => (
                            <Step key={step.label}>
                                <StepLabel
                                    StepIconProps={{
                                        sx: {
                                            '&.Mui-completed': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            '&.Mui-active': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        }
                                    }}
                                >
                                    {step.label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                {currentScreen === 'selectAssessment' && (
                    !selectedAssessment ? (
                        <>
                    <Typography className={classes.title} component="h1" variant="h5" style={{ fontWeight: 'bold', marginTop: '25px', textAlign: 'center' }}>
                        Select An Assessment Type
                    </Typography>
                    <Typography variant="body1" sx={{ padding: { sm: '10px 150px', xs: '0px' } }} style={{ fontSize: '25px', textAlign: "center", color: '#ff6468' }}>
                        Please select the type of assessment you would like to include in your program.
                    </Typography>

                    <Box display="flex" alignItems="start" sx={{ flexDirection: { xs: 'column', sm: 'row' }, mt:4 }}>
                        {/* Program-Specific Assessment Card */}
                        <Card className={classes.card} style={{position:'relative',}}>
                            <CardContent className={classes.cardContent}>
                                <Typography variant="h6" style={{ textAlign: 'center', color: "#ED6628", fontSize: '23px', padding: '25px' }}>
                                    Program-Specific <br/> Assessment
                                </Typography>
                                <Typography component="div" style={{ padding: '10px 20px 0px 20px' }}>
                                    This assessment is specifically curated based on your program's content alignment.
                                </Typography>
                                <Grid container spacing={0.5} className={classes.nestedCardContainer}>
                                    <Grid item xs={12}>
                                        <Button
                                                    id="contact-us-button"
                                            style={{position:'absolute', bottom:'12px', left:'125px'}}
                                            className={`${classes.assessmentButton} ${classes.contactUsButton}`}
                                            onClick={() => handleCardClick(ASSESSMENT_REQ_TYPES.PRE_SELECT_PRE_POST)}
                                        >
                                            <Typography variant="button">Select</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* Standard Cyber Citizenship Assessment Card */}
                        <Card className={classes.card} style={{position:'relative',}}>
                            <CardContent className={classes.cardContent}>
                                <Typography variant="h6" style={{ textAlign: 'center', color: "#ED6628", fontSize: '23px', padding: '25px' }}>
                                    CPC Index<br/>
                                    Standards Assessment
                                </Typography>
                                <Typography component="div" style={{ height: '155px', padding: '10px 20px 0px 20px' }}>
                                    This assessment aligns your program with the CPC Index and connect directly to its global benchmarking framework.
                                </Typography>
                                <Grid container className={classes.nestedCardContainer}>
                                    <Grid item xs={12}>
                                        <Button
                                            id="contact-us-button"
                                            style={{position:'absolute', bottom:'12px', left:'125px'}}
                                            className={`${classes.assessmentButton} ${classes.contactUsButton}`}
                                            onClick={() => handleCardClick(ASSESSMENT_REQ_TYPES.STANDARD_DCT)}
                                        >
                                            <Typography variant="button">Select</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        {/* Custom Assessment Card */}
                        <Card className={classes.card} style={{position:'relative',}}>
                        <CardContent className={classes.cardContent}>
                                <Typography variant="h6" style={{ textAlign: 'center', color: "#ED6628", fontSize: '24px', padding: '25px' }}>
                                    Custom <br/> Assessment
                                </Typography>
                                <Typography component="div" style={{ height: '192px', padding: '10px 20px 0px 20px' }}>
                                    Looking to create a special type of assessment? We can work with you to develop one.
                                </Typography>
                                <Grid container className={classes.nestedCardContainer}>
                                    <Grid item xs={12}>
                                        <Button
                                                    id="contact-us-button"
                                                    style={{position:'absolute', bottom:'12px', left:'125px'}}
                                                    className={`${classes.assessmentButton} ${classes.contactUsButton}`}
                                                >
                                                    <Typography variant="button">Contact Us</Typography>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Box>
                        </>
                    ) : (
                        <div style={{
                            minHeight: '80vh',
                            backgroundColor:'#F4EEEE',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '20px'
                        }}>
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <Typography variant="body1" sx={{ padding: { sm: '10px 150px', xs: '0px' } }} style={{ fontSize: '25px', textAlign: "center", }}>
                                Please answer the following questions in regards to your assessment rollout.
                            </Typography>

                            <FormControl fullWidth variant="outlined" margin="normal">
                                <TextField
                                    style={{backgroundColor:'#fff'}}
                                    label="Expected number of users"
                                    className={classes.textField}
                                    id="noOfUsers"
                                    name="noOfUsers"
                                    type="number"
                                    value={formData.noOfUsers}
                                    onChange={handleInputChange}
                                    variant="outlined"
                                    required
                                />
                            </FormControl>

                            {/*<FormControl fullWidth variant="outlined" margin="normal">*/}
                            {/*    <InputLabel>Which delivery options do you prefer?</InputLabel>*/}
                            {/*    <Select*/}
                            {/*        style={{ backgroundColor: '#fff' }}*/}
                            {/*        id="onlineSystem"*/}
                            {/*        value={formData.onlineSystem}*/}
                            {/*        label="Which delivery options do you prefer?"*/}
                            {/*        name="onlineSystem"*/}
                            {/*        onChange={handleInputChange}*/}
                            {/*        required*/}
                            {/*    >*/}
                            {/*        {ONLINE_SYSTEM.map(option => (*/}
                            {/*            <MenuItem key={option.value} value={option.value}>*/}
                            {/*                {option.label}*/}
                            {/*            </MenuItem>*/}
                            {/*        ))}*/}
                            {/*    </Select>*/}
                            {/*</FormControl>*/}

                            {/*{formData.onlineSystem === 'yes' && (*/}
                            {/*    <>*/}
                            {/*        <FormControl fullWidth variant="outlined" margin="normal">*/}
                            {/*            <TextField*/}
                            {/*                style={{ backgroundColor: '#fff' }}*/}
                            {/*                label="Callback URL"*/}
                            {/*                name="callBackUrl"*/}
                            {/*                value={formData.callBackUrl}*/}
                            {/*                onChange={handleInputChange}*/}
                            {/*                required*/}
                            {/*            />*/}
                            {/*        </FormControl>*/}
                            {/*        <FormControl fullWidth variant="outlined" margin="normal">*/}
                            {/*            <TextField*/}
                            {/*                style={{ backgroundColor: '#fff' }}*/}
                            {/*                label="Callback key"*/}
                            {/*                name="callBackKey"*/}
                            {/*                value={formData.callBackKey}*/}
                            {/*                onChange={handleInputChange}*/}
                            {/*                required*/}
                            {/*            />*/}
                            {/*        </FormControl>*/}
                            {/*    </>*/}
                            {/*)}*/}

                            {/*<FormControl fullWidth variant="outlined" margin="normal">*/}
                            {/*    <InputLabel>Include custom impact metrics?</InputLabel>*/}
                            {/*    <Select*/}
                            {/*        name="requirements"*/}
                            {/*        value={formData.requirements}*/}
                            {/*        onChange={handleInputChange}*/}
                            {/*        required*/}
                            {/*    >*/}
                            {/*        <MenuItem value="yes">Yes</MenuItem>*/}
                            {/*        <MenuItem value="no">No</MenuItem>*/}
                            {/*    </Select>*/}
                            {/*</FormControl>*/}

                            {/*{formData.requirements === 'yes' && (*/}
                            {/*    <FormControl fullWidth variant="outlined" margin="normal">*/}
                            {/*        <TextField*/}
                            {/*            label="Details of requirements"*/}
                            {/*            name="requirementDesc"*/}
                            {/*            value={formData.requirementDesc}*/}
                            {/*            onChange={handleInputChange}*/}
                            {/*            multiline*/}
                            {/*            rows={4}*/}
                            {/*            required*/}
                            {/*        />*/}
                            {/*    </FormControl>*/}
                            {/*)}*/}

                            <FormControl fullWidth variant="outlined" margin="normal">
                                <Autocomplete
                                    multiple
                                    style={{backgroundColor:'#fff'}}
                                    fullWidth={true}
                                    className={classes.textField}
                                    name="nameOfCountries"
                                    options={Object.values(REGIONS)}
                                    getOptionLabel={(option) => option.label}
                                    getOptionSelected={(option, value) => option.value === value.value}
                                    onChange={handleCountryChange}
                                    disableCloseOnSelect
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            fullWidth={true}
                                            variant="outlined"
                                            label="Which countries are you intending to roll the assessment to? (Select all that apply)"
                                            InputLabelProps={ { required: true }}
                                        />
                                    )}
                                />
                            </FormControl>

                            <Box display="flex" justifyContent="flex-end" mt={4}>
                                {/*<Button*/}
                                {/*    className={classes.button}*/}
                                {/*    variant="contained"*/}
                                {/*    color="primary"*/}
                                {/*    // onClick={handleBackFromPreview}*/}
                                {/*    style={{ width: '10vw', backgroundColor: '#052F44', color: 'white', borderRadius: '15px' }}*/}
                                {/*>*/}
                                {/*    Back*/}
                                {/*</Button>*/}
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={handleSubmit}
                                    disabled={status > APP_STATUS.READY_TO_CERTIFY}
                                    style={{ width: '10vw', backgroundColor: '#052F44', color: 'white', borderRadius: '15px' }}
                                >
                                    Next
                                </Button>
                            </Box>
                            </form>
                        </div>
                    )
                )}
            </Container>
                    );
               }

             if (status === APP_STATUS.ASSESSMENTS_READY) {
              return (
              <Container className={classes.container}>
                {currentScreen === 'preview' ? (
                // Preview Screen
                    <>
                        <Box sx={{ p: 3 }}>
                            <Stepper
                                activeStep={activeStep}
                                alternativeLabel
                                sx={{
                                    '& .MuiStepLabel-root .Mui-completed': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-active': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-disabled': {
                                        color: '#ff6468ff',
                                        opacity: 0.5
                                    },
                                    '& .MuiStepConnector-root .MuiStepConnector-line': {
                                        borderColor: '#ff6468ff',
                                        borderTopWidth: '6px',
                                        // marginTop: '-12px'
                                    }
                                }}
                            >
                                {ASSESSMENT_STEPS.map((step) => (
                                    <Step key={step.label}>
                                        <StepLabel
                                            StepIconProps={{
                                                sx: {
                                                    '&.Mui-completed': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    '&.Mui-active': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    fontSize: '1.7rem',
                                                    '& .MuiStepIcon-text': {
                                                        display: 'none'
                                                    }
                                                }
                                            }}
                                        >
                                            {step.label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>

                        <Typography
                            component="h1"
                            className={classes.title}
                            variant="h5"
                            style={{ fontWeight: "bold", marginTop: '30px', marginBottom: '20px' }}
                        >
                            Preview Assessment
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ padding: { sm: '10px 150px', xs: '0px' } }}
                            style={{ fontSize: '20px', marginBottom: '40px' }}
                        >
                            You can preview your assessment by following the link here. The assessment will open in a new tab, so you can see what it’s like as a learner to access the assessment. Once you’re done checking it, click <strong>"Next"</strong>.
                        </Typography>
                        <Box sx={{ marginBottom: '40px', marginTop: '50px',textAlign:'center', }}>
                            <Button
                                className={classes.customButton2}
                                style={{ backgroundColor: '#0097a7', padding:'10px 20px !important' }}
                                variant="contained"
                                color="secondary"
                                onClick={goToDqAssess}
                            >
                                Preview Your Assessment
                            </Button>
                        </Box>
                        <Box display="flex" justifyContent="center" gap={8}>
                            {/*<Button*/}
                            {/*    className={classes.dialogButton}*/}
                            {/*    variant="contained"*/}
                            {/*    style={{ width: '165px',marginRight:'20px', padding: '15px 0px !important' }}*/}
                            {/*    // onClick={handleBackToSelection}*/}
                            {/*>*/}
                            {/*    Back*/}
                            {/*</Button>*/}
                            <Button
                                className={classes.dialogButton}
                                variant="contained"
                                color="primary"
                                style={{ width: '165px', padding: '15px 0px !important' }}
                                onClick={() => {
                                    setCurrentScreen('publish');
                                    setCurrentStatus('PUBLISH_ASSESS');
                                }}
                            >
                                Next
                            </Button>
                        </Box>
                    </>
            ) : (
                // Publish Confirmation Screen
                    <>
                        <Box sx={{ p: 3 }}>
                            <Stepper
                                activeStep={activeStep}
                                alternativeLabel
                                sx={{
                                    '& .MuiStepLabel-root .Mui-completed': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-active': {
                                        color: '#ff6468ff'
                                    },
                                    '& .MuiStepLabel-root .Mui-disabled': {
                                        color: '#ff6468ff',
                                        opacity: 0.5
                                    },
                                    '& .MuiStepConnector-root .MuiStepConnector-line': {
                                        borderColor: '#ff6468ff',
                                        borderTopWidth: '6px',
                                        // marginTop: '-12px'
                                    }
                                }}
                            >
                                {ASSESSMENT_STEPS.map((step) => (
                                    <Step key={step.label}>
                                        <StepLabel
                                            StepIconProps={{
                                                sx: {
                                                    '&.Mui-completed': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    '&.Mui-active': {
                                                        color: '#ff6468ff',
                                                        fontSize: '1.7rem',
                                                        '& .MuiStepIcon-text': {
                                                            display: 'none'
                                                        }
                                                    },
                                                    fontSize: '1.7rem',
                                                    '& .MuiStepIcon-text': {
                                                        display: 'none'
                                                    }
                                                }
                                            }}
                                        >
                                            {step.label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                        <Typography
                            component="h1"
                            className={classes.title}
                            variant="h5"
                            style={{ fontWeight: "bold", marginTop: '30px', marginBottom: '40px' }}
                        >
                            Publishing Your Assessment
                        </Typography>
                        <Typography
                            variant="body1"
                            style={{ fontSize: '18px', marginBottom: '20px', textAlign: 'left', padding: '0 30px' }}
                        >
                            If you would like to request any updates or believe there are errors in your assessment,
                            please contact us at <strong><a href="mailto:research@dqforall.com"> research@dqforall.com</a>.</strong> We’ll review your request and get back to you within 2 business days.
                        </Typography>
                        <Typography
                            variant="body1"
                            style={{ fontSize: '18px', marginBottom: '150px', textAlign: 'left', padding: '0 30px' }}
                        >
                            If everything looks good and you're ready to proceed, click <strong>“Publish”</strong>.
                            <br /><br />
                            <strong style={{textDecoration:'underline'}}>Please note: This action is final and cannot be undone</strong>, so be sure to review everything carefully before continuing.
                            If you need to check again, click <strong>“Back”</strong> to preview your assessment.
                        </Typography>
                        <Box display="flex" justifyContent="center" gap={8}>
                            <Button
                                className={classes.dialogButton}
                                variant="contained"
                                style={{ width: '140px', padding: '15px 0px !important' }}
                                onClick={() => {
                                    setCurrentScreen('preview');
                                    setCurrentStatus('PREVIEW_ASSESS');
                                }}
                            >
                                Back
                            </Button>
                            <Button
                                className={classes.customButton2}
                                variant="contained"
                                style={{ width: '140px',marginLeft:'20px',backgroundColor: '#0097a7 !important', padding: '15px 0px !important' }}
                                onClick={handleOpenDialog}
                            >
                                Publish
                            </Button>
                        </Box>
                    </>
            )}

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        width: '32%',
                        height: '35%',
                        maxWidth: 'none',
                        borderRadius:'20px',
                        paddingTop:'20px',
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign:'center'}}>
                    Are you sure you want to publish?
                </DialogTitle>
                <DialogContent style={{textAlign:'center', color:'#000000',fontWeight:'normal'}}>
                    <DialogContentText id="alert-dialog-description">
                        Once you publish, this action cannot be undone.
                        Please make sure everything is final before continuing.
                    </DialogContentText>
                </DialogContent>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    padding="16px 24px"
                    gap="16px"
                >
                    <Button
                        onClick={handleCloseDialog}
                        className={classes.dialogButton}
                        variant="contained"
                        style={{ backgroundColor:'#ff6468',lineHeight:'1.2 !important', fontSize:'13px !important',padding: '15px 0px !important', marginRight: '16px' }}
                    >
                        I need to <br/> check again
                    </Button>
                    <Button
                        onClick={handlePublishConfirmed}
                        className={classes.customButton2}
                        style={{ backgroundColor: '#0097a7',lineHeight:'1.2 !important', fontSize:'13px !important',padding: '15px 0px !important' }}
                        variant="contained"
                        color="secondary"
                    >
                        Yes, <br/> Publish it
                    </Button>
                </Box>
              </Dialog>
        </Container>
    );
}
    // Default under review state
return (
        <Container className={classes.assessmentContainer}>
            {submittedFormData && (
                <Dialog
                    open={openAssessDialog}
                    onClose={() => {}}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        style: {
                            width: '30%',
                            height: '30%',
                            maxWidth: 'none',
                            borderRadius:'20px',
                            paddingTop:'20px',
                        },
                    }}
                >
                    <DialogTitle id="alert-dialog-title" style={{textAlign:'center'}}>
                        Please wait.
                    </DialogTitle>
                    <DialogContent style={{textAlign:'center', color:'#000000',fontWeight:'normal'}}>
                        <DialogContentText id="alert-dialog-description">
                            Once ready, you will be able to preview assessment.
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            )}
        </Container>
    );
};

export default RatingSelectAssessmentView;